// Extrait de ClinicAdminDashboard.js (handover bloc F3-A) — 100 % présentationnel (cartes KPI + carte RDV à valider).
import { Users, Activity, Eye, BarChart3, AlertTriangle, ChevronRight } from "lucide-react";
import { KpiCard } from "@/components/shared/KpiCard";

export default function ClinicKpiHeader({ kpi, pendingMatch, onOpenPending }) {
  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full">
        <KpiCard label="Patients actifs" value={kpi?.patients?.total} icon={Users} testId="kpi-active-patients" />
        <KpiCard label="Critiques" value={kpi?.patients?.critical} icon={Activity} tone="danger" testId="kpi-critical" />
        <KpiCard label="À surveiller" value={kpi?.patients?.toMonitor} icon={Eye} tone="warning" testId="kpi-to-monitor" />
        <KpiCard label="Alertes ouvertes" value={kpi?.alerts?.open} icon={BarChart3} tone="warning" testId="kpi-open-alerts" />
      </div>

      {/* RDV à valider — accès rapide vers la file de validation */}
      <button
        type="button"
        data-testid="pending-match-card"
        onClick={onOpenPending}
        className={`w-full text-left dash-card flex items-center justify-between transition-colors ${
          pendingMatch.total > 0
            ? "border-l-4 border-red-500 hover:bg-red-50"
            : "hover:bg-slate-50"
        }`}
      >
        <div className="flex items-center gap-3">
          <div className={`p-3 rounded-xl ${
            pendingMatch.total > 0 ? "bg-red-50 text-red-600" : "bg-slate-100 text-slate-500"
          }`}>
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <p className="font-semibold text-slate-800">RDV à valider</p>
              {pendingMatch.total > 0 && (
                <span
                  data-testid="pending-match-badge"
                  className="inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 text-xs font-bold rounded-full bg-red-600 text-white"
                >
                  {pendingMatch.total}
                </span>
              )}
            </div>
            <p className="text-sm text-slate-500">
              {pendingMatch.total === 0
                ? "Aucun rendez-vous importé en attente"
                : `${pendingMatch.toValidate} à valider · ${pendingMatch.unmatched} non trouvé${pendingMatch.unmatched > 1 ? "s" : ""}`}
            </p>
          </div>
        </div>
        <span className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-sm font-medium ${
          pendingMatch.total > 0
            ? "bg-red-600 text-white"
            : "bg-slate-100 text-slate-600"
        }`}>
          Gérer <ChevronRight className="w-4 h-4" />
        </span>
      </button>
    </>
  );
}
